import React from "react";
import {
	Box,
	Container,
	Typography,
	Grid,
	IconButton,
	List,
	MenuItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	colors,
	useMediaQuery,
	useTheme
} from "@mui/material";
import { ArrowBack, Person, Email, Lock, ShoppingBag, Receipt, Diversity3 } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { MyAccountContainer, BackButton } from "./styles";
const MyAccount = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const isPersonalSelected = location.pathname.includes("/personal");
	const isInvitationSelected = location.pathname.includes("/invitations");
	const isSecuritySelected = location.pathname.includes("/security");
	const isOrdersSelected = location.pathname.includes("/orders");
	const isTransactionsSelected = location.pathname.includes("/transactions");
	const isAffiliateSelected = location.pathname.includes("/affiliate");
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const handleGoBack = () => {
		navigate("/");
	};

	return (
		<Container maxWidth={"xl"}>
			<Box mt={7} height={"94vh"} p={1}>
				<Box display={"flex"} alignItems={"center"} justifyContent={"flex-start"} my={2}>
					<BackButton onClick={handleGoBack}>
						<IconButton>
							<ArrowBack width={20} />
						</IconButton>
						<Typography>MyAccount</Typography>
					</BackButton>
				</Box>
				<MyAccountContainer container spacing={4} alignItems={"flex-start"}>
					<Grid className={"menu"} size={isSmallerScreen ? 12 : 3}>
						<List className={"menu-tabs"}>
							<MenuItem selected={isInvitationSelected} onClick={() => navigate("/myAccount/invitations")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Email />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Invitations" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isOrdersSelected} onClick={() => navigate("/myAccount/orders")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<ShoppingBag />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Orders" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isTransactionsSelected} onClick={() => navigate("/myAccount/transactions")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Receipt />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Transactions" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isAffiliateSelected} onClick={() => navigate("/myAccount/affiliate")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Diversity3 />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Affiliate Program" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isSecuritySelected} onClick={() => navigate("/myAccount/security")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Lock />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Security" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isPersonalSelected} onClick={() => navigate("/myAccount/personal")}>
								<ListItemButton>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Person />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Personal" />}
								</ListItemButton>
							</MenuItem>
						</List>
					</Grid>
					<Grid
						size={isSmallerScreen ? 12 : 9}
						style={{ backgroundColor: colors.grey[50], padding: 15, minHeight: "70vh", borderRadius: "5px" }}
					>
						<Outlet />
					</Grid>
				</MyAccountContainer>
			</Box>
		</Container>
	);
};

export default MyAccount;
